import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class PaginatorIntlService extends MatPaginatorIntl {
  public override firstPageLabel: string = 'Erste Seite';
  public override itemsPerPageLabel: string = 'Zeilen pro Seite:';
  public override lastPageLabel: string = 'Letzte Seite';
  public override nextPageLabel: string = 'Nächste Seite';
  public override previousPageLabel: string = 'Vorherige Seite';
  public override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0) {
      return 'Seite 1 von 1';
    }

    const amountPages: number = Math.ceil(length / pageSize);

    return `Seite ${page + 1} von ${amountPages}`;
  };
}
